export default __webpack_public_path__ + "static/media/MishtiTakyonDarkMini.ab60c0ae.png";